export const CS = {
    translations: {
        notifications: 'Oznámení',
        markAllAsRead: 'Označit všechna jako přečtená',
        poweredBy: 'Přináší',
        settings: 'Nastavení',
        noNewNotification: 'Zatím tu není nic nového k vidění',
    },
    lang: 'cs',
};
//# sourceMappingURL=cs.js.map